import { render, staticRenderFns } from "./InfoListPage.vue?vue&type=template&id=232b94fa&scoped=true&"
import script from "./InfoListPage.vue?vue&type=script&lang=js&"
export * from "./InfoListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232b94fa",
  null
  
)

export default component.exports